import { useQuery } from '@tanstack/react-query';
import { distributionKeys } from '../api/keys';
import { fetchDistribution, fetchHealth, fetchServerEndpoints } from '../api/requests';

export function useDistribution() {
  return useQuery({
    queryKey: distributionKeys.overview,
    queryFn: ({ signal }) => fetchDistribution(signal),
  });
}

export function useServerEndpoints() {
  return useQuery({
    queryKey: distributionKeys.endpoints,
    queryFn: ({ signal }) => fetchServerEndpoints(signal),
  });
}

/** Re-checked every 30 s while the page is open, as the previous app's status badge did. */
export function useHealth() {
  return useQuery({
    queryKey: distributionKeys.health,
    queryFn: ({ signal }) => fetchHealth(signal),
    refetchInterval: 30_000,
    staleTime: 10_000,
    retry: false,
  });
}
